import { graphql } from "../gql";

export const createReviewedAuditFindingMutationDoc = graphql(`
  mutation createReviewedAuditFinding(
    $reviewedAuditFinding: ReviewedAuditFindingInput!
  ) {
    createReviewedAuditFinding(
      input: { reviewedAuditFinding: $reviewedAuditFinding }
    ) {
      reviewedAuditFinding {
        ...reviewedAuditFindingFragment
        authorId
        auditFinding {
          ...auditFindingWithReviewFragment
        }
      }
    }
  }
`);
